import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import TablePageState from '@/data/models/tables/TablePageState'

@RepoSettings<Endpoint>({
  model: TablePageState,
})
@injectable()
@injectFromBase()
export default class TablePageStateRepository extends OrmApiRepository<TablePageState> {
  public setIsRowsLoading(tableId: string, pageKey: string, isLoading: boolean) {
    return this.insertOrUpdate([{ id: this.getId(tableId, pageKey), isLoading }])
  }

  public getRowsLoading(tableId: string, pageKey: string) {
    return this.findEntityByIdOrNull(this.getId(tableId, pageKey))?.isLoading ?? false
  }

  public cleanUp(tableId: string) {
    this.deleteByCondition((item) => item.id.startsWith(tableId))
  }

  private getId(tableId: string, pageKey: string): string {
    return `${tableId}:${pageKey}`
  }
}
